module.exports = "../assets/yachtfull-logo-white-bg-no-brands.1a2ae206.svg";